import axios from 'axios';
import { getEndpoint, getRequestHeaders } from './config'

export default function (sessionId: string, clear: boolean = false) {
    return new Promise<any>((resolve, reject) => {
        axios
            .delete(
                getEndpoint(clear?'sessions/{id}?clear=true':'sessions/{id}', { id: sessionId }),
                getRequestHeaders(true)
            )
            .then(function (response: any) {
                resolve();
            })
            .catch(function (rs: any) {
                reject(rs);
            });
    });
}